import { fromJS } from 'immutable';

import {
  CHANGE_LOCALE,
  DEFAULT_LOCALE,
} from 'containers/LanguageProvider/constants';
import { RESET_STORE } from 'containers/LoginPage/constants';

interface ChangeLocaleAction {
  type: 'CHANGE_LOCALE' | 'RESET_STORE' | null;
  locale: string;
}

const initialState: any = fromJS({
  locale: DEFAULT_LOCALE,
});

const languageReducer = (state = initialState, action: ChangeLocaleAction) => {
  switch (action.type) {
    case CHANGE_LOCALE:
      return state.set('locale', fromJS(action.locale));
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default languageReducer;
